import { InfoOutlined } from '@material-ui/icons'
import { Box, Typography } from '@mui/material'
import React from 'react'

function NoDataMessage({message , icon}:{message?:string,icon?:any}) {
    return (
        <Box sx={{ color: 'gray', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }} alignItems={'center'}>
            {icon}
            <Typography variant='h6' sx={{ color: 'gray' }} textAlign={'center'}>
                {message || "No Data"}
            </Typography>
        </Box>
    )
} 

export default NoDataMessage